// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"c0b27401","267":"e0ebf707","672":"8c9b8ca8","858":"a1bac502","948":"183759a5"}[chunkId] + ".chunk.css";
};